
    import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import _ from 'lodash';
    import api from '@/services/Api';
    import axios, { AxiosResponse, CancelTokenSource } from 'axios';
    import { VAutocomplete } from '@/types/Components';
    import Beleg from '@/types/Beleg';

    export type RechnungSearchItem = {
        belegnr?: string;
        patnr?: number;
        id?: number;
        divider?: boolean;
        created?: string | any;
    };

    export type PatientSearchFilter = {
        patnr?: number;
    };

    @Component
    export default class RechnungSearch extends Vue {
        @Model('change') data!: RechnungSearchItem[];
        @Prop({ default: () => ({ patnr: undefined })}) filter!: PatientSearchFilter;

        public $refs!: {
            search: VAutocomplete;
        };

        public search = null;
        public select: RechnungSearchItem | null = null;
        public loading = false;

        public source: CancelTokenSource | null = null;
        public searchApiCall: _.DebouncedFunc<(query: string) => void> | null = null;

        @Watch('search', { immediate: true })
        public searchChange(search: string): void {
            search && search !== (this.select?.belegnr ?? '') && this.querySelections(search);
        }

        @Watch('select')
        public onChangeSelect(select: RechnungSearchItem): void {
            this.$emit('select', select);
        }

        public reset(): void {
            this.$refs.search.reset();
            this.$refs.search.blur();
        }

        public mounted(): void {
            this.search = null;
            this.select = null;
        }

        public destroyed(): void {
            if (this.source) {
                this.source.cancel('cancel ivs/patienten/rechnungsearch');
            }
        }

        public onClickEnter(): void {
            const query = this.search ?? '';
            if (query.length === 0) {
                this.searchPatient(query);
            }
        }

        public querySelections(search: string | null): void {
            const query = search ?? '';
            if (query.length < 5) {
                return;
            }

            this.searchPatient(query);
        }

        public searchPatient(query: string): void {
            this.loading = true;

            if (!this.searchApiCall) {
                this.searchApiCall = _.debounce((query: string) => {
                    if (this.source) {
                        this.source.cancel('cancel ivs/patienten/rechnungsearch');
                    }

                    this.source = axios.CancelToken.source();

                    api.post('ivs/patienten/rechnungsearch', { query, filter: this.filter }, { cancelToken: this.source.token })
                        .then((res: AxiosResponse) => {
                            const items: RechnungSearchItem[] = [];

                            res.data.body
                                .map((data: Beleg) => new Beleg(data))
                                .forEach((beleg: Beleg, idx: number) => {
                                    items.push({
                                        belegnr: [beleg.jahr, beleg.belegnr].join(' | '),
                                        id: beleg.patnr as number,
                                        created: ['erstellt am', this.$d(beleg.datum)].join(' '),
                                    });

                                    if (idx !== res.data.body.length - 1) {
                                        items.push({ divider: true });
                                    }
                                });

                            this.$emit('change', items);
                            this.loading = false;
                        })
                        .catch(console.error)
                        .finally(() => this.source = null);
                }, 500);
            }

            this.searchApiCall(query);
        }
    }
